<template>
  <div>
      <vs-tabs
        :position="isSmallerScreen ? 'top' : 'left'"
        class="tabs-shadow-none cstm_vert_tabs"
        id="profile-tabs"
        :key="isSmallerScreen"
        v-model="tabIndex"
      >
      <vs-tab
          icon="euro"
          :label="!isSmallerScreen ? 'Currency List' : ''"
        >
          <vx-card no-shadow>
         <form data-vv-scope="CurrencySettings">
            <div class="p-1">
              <label class="vs-input--label">Currency List</label>
              <v-select
             :disabled="can_update_currency?false:true"
              append-to-body
                class="w-full"
                label="currency_name"
                :options="currencyLists"
                name="currency_name"
                v-validate="'required'"
                :reduce="(item) => item.id"
                v-model="currency_id"
              >
              </v-select>
             
              
              <span
                v-show="errors.has('CurrencySettings.currencyList')"
                class="text-danger"
                >{{ errors.first("CurrencySettings.currencyList") }}</span
              >
              
            </div>
             <div class="flex items-center justify-center">
              <vs-button @click.prevent="saveCurrencySettings()">Update Settings</vs-button>
            </div>

         </form>
         </vx-card>
      </vs-tab>
        <vs-tab
          icon="event"
          :label="!isSmallerScreen ? 'Date & Time' : ''"
        >
         <vx-card no-shadow>
            <form data-vv-scope="GeneralSettings">
            <label class="vs-input--label">Platform Time Zone</label>
              <v-select
              append-to-body
                class="w-full"
                label="location"
                :options="platformTimeZone"
                :reduce="(item) => item.timezone_id"
                name="platformzone"
                v-validate="'required'"
                v-model="platform_timezone_id"
              ></v-select>
              <span
                v-show="errors.has('GeneralSettings.platformzone')"
                class="text-danger"
                >{{ errors.first("GeneralSettings.platformzone") }}</span
              >
              <label>Time Format</label>
                <v-select
              append-to-body
                class="w-full"
                label="value"
                :options="timeFormat"
                :reduce="(item) => item.id"
                name="value"
                v-validate="'required'"
                v-model="time_format_id"
              ></v-select>
               <label>Date Format</label>
                <v-select
              append-to-body
                class="w-full"
                label="value"
                :options="dateFormat"
                :reduce="(item) => item.id"
                name="value"
                v-validate="'required'"
                v-model="date_format_id"
              ></v-select>
               <label>Week Start</label>
                <v-select
              append-to-body
                class="w-full"
                label="value"
                :options="weekStart"
                :reduce="(item) => item.id"
                name="value"
                v-validate="'required'"
                v-model="start_day_id"
              ></v-select>
               <div class="flex items-center justify-center">
              <vs-button @click.prevent="saveSettings()">Update Settings</vs-button>
            </div>
            </form>
         </vx-card>
        </vs-tab>
          <vs-tab
          icon="email"
          :label="!isSmallerScreen ? 'Email Settings' : ''"
        >
         <vx-card no-shadow>
            <form data-vv-scope="GeneralSettings">
               <vs-row>
              <!-- <pre>{{ contact_email }}</pre> -->
              <vs-col
                :vs-xs="12"
                :vs-md="12"
                :vs-lg="12"
                v-for="(eachemail, counter) in contact_email"
                :key="counter"
              >
                <div class="flex items-center ml-auto p-1 py-2">
                  <vs-tooltip color="primary" text="Default Email">
                    <vs-checkbox
                      v-model="eachemail.default"
                      @change="handleEmailDefault(counter)"
                    ></vs-checkbox>
                    <!-- {{eachemail.default}} -->
                  </vs-tooltip>
                  <vs-input
                    v-model="eachemail.email"
                    class="custom_Input mr-3"
                    icon-pack="feather"
                    icon="icon-edit"
                    icon-after
                    label="Enter your Email"
                    style="width: 100%"
                    v-validate="'required|email'"
                    :data-vv-name="`email${counter}`"
                    :name="`email${counter}`"
                  />
                  <!-- {{eachemail.default}} -->
                  
                  <span
                    v-show="errors.has(`GeneralSettings.email${counter}`)"
                    class="text-danger"
                    >{{ errors.first(`GeneralSettings.email${counter}`) }}</span
                  >
                  <vs-button
                    class="custom_Input"
                    color="danger"
                    icon-pack="feather"
                    icon="icon-x"
                    @click="deleteemail(counter)"
                  ></vs-button>
                  <!-- <vs-button
                  v-if="contact_email.length === counter + 1"
                    class="custom_Input ml-2"
                    color="success"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="addNewemail()"
                  ></vs-button> -->
                </div>
              </vs-col>
              <!-- <vs-button @click="addNewemail()" class="ml-auto mt-2 mb-4"
                >Add More Email</vs-button
              > -->
            </vs-row>
             
            <vs-card class="cstm-card">
              <div class="text-center">
                <svg style="width: 80px; height: 80px;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" fill="#5FCDFF" stroke="#119CDB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z" fill="#FFE350" stroke="#FF8E24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M20 8V14" stroke="#00B6C1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 11H17" stroke="#00B6C1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p style="font-size: 16px; font-weight: 600;" class="mb-3">Send automatic. Sign Up invitation</p>
                <vs-switch class="mx-auto sign_up_toggle" v-model="invitation_setting">
                  <span slot="on">On</span>
                  <span slot="off">Off</span>
                </vs-switch>
              </div>
            </vs-card>
             <content-component
              v-model="header"
                      :file_repository_id="repository_id"

              label="Email Header"
            ></content-component>

              <content-component
              v-model="footer"
                      :file_repository_id="repository_id"

              label="Email Footer"
            ></content-component>
            <div class="flex flex-wrap justify-between items-center">
  <vs-button class=""
            @click.prevent="previewHeaderFooter()"
            >Preview</vs-button>
            <vs-button 
            @click.prevent="verification()"
            >Verification</vs-button>
              <vs-button @click.prevent="saveSettings()">Update Settings</vs-button>
            </div>
            </form>
         </vx-card>
        </vs-tab>
        <vs-tab
          icon="airplane_ticket"
          :label="!isSmallerScreen ? 'Holiday Settings' : ''"
        >
          <vx-card no-shadow>
         <form data-vv-scope="GeneralSettings">
           <vs-card class="cstm-card mt-4">
              <div slot="header">
              <h5 style="padding: 10px;">Holiday Settings</h5>
            </div>
          <!-- <holiday-calendar-component
          name="General"
          :custom="1"
        ></holiday-calendar-component> -->
        <holiday-tab></holiday-tab>
        </vs-card>
                 </form>
         </vx-card>
      </vs-tab>
       <vs-tab
          icon="event"
          :label="!isSmallerScreen ? 'School Schedule' : ''"
        >
        <school-schedule ></school-schedule>
       </vs-tab>

      <vs-tab
        icon="settings"
        :label="!isSmallerScreen ? 'Theme Settings' : ''"
      >
        <vx-card no-shadow>
          <div class="flex flex-1 flex-col mb-12">
            <h4>Logo</h4>
            <div class="flex flex-1 mt-5">
              <div class="flex flex-col">
                <vs-avatar :src="themeSettings.logo_url" size="70px" class="mr-4 mb-4 object-contain" />
              </div>
              <div class="flex flex-col ml-10">
                <div class="flex">
                  <vs-button @click="changeLogo = !changeLogo">Change Logo</vs-button>
                  <vs-button @click="removeLogo()" class="ml-6" type="border">Reset</vs-button>
                </div>
                <div class="flex justify-center mt-2">
                  <p class="text-sm mt-2">Allowed JPG, JPEG or PNG. Max size of 50kb</p>
                </div>
              </div>
            </div>
            <div v-if="changeLogo" class="cstm_vuefileagent_holder w-full">
              <file-upload-component
                section_type="courseHeader"
                @getImage="getImageUrl"
                :file_repository_id="repository_id"
              ></file-upload-component>
            </div>
          </div>
          <div class="flex flex-1 flex-col">
            <h4>Colors</h4>
            <div class="flex flex-wrap mt-5">
              <div class="p-2">
                <h6 class="mb-3">PRIMARY</h6>
                <div class="theme_color_holder">
                  <div class="color_holder" :style="{backgroundColor: themeSettings.primary}"></div>
                  <span class="material-icons">expand_more</span>
                  <input type="color" v-model="themeSettings.primary" />
                </div>
              </div>
              <div class="p-2">
                <h6 class="mb-3">SECONDARY</h6>
                <div class="theme_color_holder">
                  <div class="color_holder" :style="{backgroundColor: themeSettings.secondary}"></div>
                  <span class="material-icons">expand_more</span>
                  <input type="color" v-model="themeSettings.secondary" />
                </div>
              </div>
              <div class="p-2">
                <h6 class="mb-3">HEADING</h6>
                <div class="theme_color_holder">
                  <div class="color_holder" :style="{backgroundColor: themeSettings.heading}"></div>
                  <span class="material-icons">expand_more</span>
                  <input type="color" v-model="themeSettings.heading" />
                </div>
              </div>
              <div class="p-2">
                <h6 class="mb-3">TEXT</h6>
                <div class="theme_color_holder">
                  <div class="color_holder" :style="{backgroundColor: themeSettings.text}"></div>
                  <span class="material-icons">expand_more</span>
                  <input type="color" v-model="themeSettings.text" />
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-1 mt-12 justify-end">
            <vs-button type="border" class="mr-2" @click.prevent="resetSettings()">Reset Changes</vs-button>
            <vs-button @click.prevent="saveSettings()">Save Changes</vs-button>
          </div>
        </vx-card>
      </vs-tab>
           </vs-tabs>
         
 
            <!-- <vs-input
            label="Email Template"
            v-model="email_template"
            /> -->

             
            <!-- <vs-input
        class="w-full my-base"
        label-placeholder="Company"
        v-model="company"
      ></vs-input> -->

            <!-- Save & Reset Button -->

            <!-- <vs-button class="ml-4 mt-2" type="border" color="warning"
                >Reset</vs-button
              > -->
          
        
          <!-- <div slot="header">
            <h2>Settings Page</h2>
          </div> -->

          <!-- <vs-card class="cstm-card mt-4">
            <div slot="header">
              <h3>Holiday Settings</h3>
            </div>
            <date-range-picker
              ref="picker"
              class="w-full holiday-picker"
              :opens="opens"
              :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
              :minDate="minDate" :maxDate="maxDate"
              :singleDatePicker="'range'"
              :timePicker="true"
              :timePicker24Hour="timePicker24Hour"
              :showWeekNumbers="showWeekNumbers"
              :showDropdowns="showDropdowns"
              :autoApply="true"
              v-model="dateRange"
              @update="updateValues"
              @select="selectDate"
              @toggle="checkOpen"
              :linkedCalendars="linkedCalendars"
              :dateFormat="dateFormat"
            >
              <template v-slot:input="picker" style="min-width: 350px; display: none;">
                <span v-if="dateRange.length == 0">Select Date Range</span>
                <span v-else>{{ picker.startDate | date }} 
                  <span v-if="!dateCheck(dateRange.startDate, dateRange.endDate)"> - {{ picker.endDate | date }}</span>
                </span>
              </template>
            </date-range-picker>
          </vs-card> -->

    <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-show="eachEventPopUp" :class="{show: eachEventPopUp}">
      <div class="cstm-modal">
        <div class="header">
          <h3>Modal</h3>
          <button @click="eachEventPopUp = false" class="close-modal">&times;</button>
        </div>
        <!-- <pre>{{eachEventInfo.backgroundColor}}</pre> -->
        
        <div class="p-4 modal-content">
          <strong>Date</strong>
          <div class="mb-2">
            <!-- {{dateRange}} -->
            <span>{{dateRange.startDate}}</span>
            <span v-if="!dateCheck(dateRange.startDate, dateRange.endDate)"> - {{dateRange.endDate}}</span>
          </div>
          <strong>Description</strong>
          <vs-textarea v-model="textarea"/>
          <vs-button class="block ml-auto mt-2">Save</vs-button>
        </div>
      </div>
    </div>
    <vs-popup  title="Preview Header and Footer" :active.sync="previewHeaderFooterModal">
          <p v-html="header"></p>
          <p>Content</p>
          <p v-html="footer"></p>

      </vs-popup>
  </div>
</template>
<script>
import schoolSchedule from './schoolSchedule'
import vSelect from 'vue-select'
import { GeneralMixins } from '@/mixins/generalMixins/GeneralMixins.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { getSetting, setSettings, verificationMailSend, currencyApi } from '@/api/setting.js'
import ContentComponent from '@/components/tinyEditor/ContentComponent.vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import HolidayCalendarComponent from './components/HolidayCalendarComponent.vue'
import holidayTab from './components/HolidayTabComponent.vue'
import FileUploadComponent from './components/FileUploadComponent.vue'
import {mapActions} from 'vuex'
import { repository } from '@/mixins/repository'

export default {
  components: {
    schoolSchedule,
    vSelect,
    flatPickr,
    ContentComponent,
    DateRangePicker,
    HolidayCalendarComponent,
    FileUploadComponent,
    holidayTab
  },
  mixins: [GeneralMixins, repository],
  name: 'Settings',
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
   
  },
  data () {
    return {
      tabIndex: 0,
      start_day_id:'',
      date_format_id:'',
      time_format_id:'',
      // datetime: null,
      timeFormat:[
        {
          id:1,
          value:'12 Hrs',
          key_val:'hh:mm a'
        },
        {
          id:2,
          value:'24 Hrs',
          key_val:'hh:mm'
        }
      ],
      dateFormat:[
        {
          id:1,
          value:'DD/MM/YY',
          key_val:'d/m/y'
          
        },
        {
          id:2,
          value:'DD/MM/YYYY',
          key_val:'d/m/Y'
          
        },
        {
          id:3,
          value:'MM/DD/YY',
          key_val:'m/d/y'
          
        },
        {
          id:4,
          value:'MM/DD/YYYY',
          key_val:'m/d/Y'
          
        },
        {
          id:5,
          value:'YYYY/MM/DD',
          key_val:'Y/m/d'
          
        },
        {
          id:6,
          value:'YYYY/DD/MM',
          key_val:'Y/d/m'
          
        }
      ],
      weekStart:[
        {
          id:0,
          value:'Sunday'
        },
        {
          id:1,
          value:'Monday'
        }
      ],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
    
      currency_id: 36,
      platform_timezone_id: null,
      invitation_setting:false,
      header: '',
      footer:'',
      tinyMceApi: '',
      contact_email: [],
      startConfigdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d',
        disable: []
      },
      can_update_currency:true,
      opens:true,
      dateRange: [],
      eachEventPopUp: false,
      changeLogo: false,
      themeSettings: {
        logo_url: JSON.parse(localStorage.getItem('localization')).logo,
        primary: JSON.parse(localStorage.getItem('localization')).primary_color,
        secondary: JSON.parse(localStorage.getItem('localization')).secondary_color,
        heading: JSON.parse(localStorage.getItem('localization')).heading_color,
        text: JSON.parse(localStorage.getItem('localization')).text_color
      },
      previewHeaderFooterModal:false,
      platform_module_id: 3
    }
  },
  mounted () {
    // this.$refs.picker.$data.open = true
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API

    this.fetchCurrencyList()
    this.fetchPLatformTimeZone()
    this.fetchSetting()
    this.getRepositoryId(this.platform_module_id)
    this.tabIndex = parseInt(this.$route.query.tab) || this.$route.params.tabularIndex
  },
  methods: {
    previewHeaderFooter () {
      this.previewHeaderFooterModal = true
    },
    
    ...mapActions(['SET_LOCALIZATION']),
    async verification () {
      try {
        const payload = {
          header:this.header,
          footer:this.footer
        }
        const customer_id = localStorage.getItem('customer_id')
        await verificationMailSend(customer_id, payload)
        this.showSuccessMessage('Success', 'Verification Mail sent Successfully', 'success')
      } catch (error) {
        console.log(error)
      }
    },
    resetSettings () {
      this.themeSettings.primary = '#3ac2d4'
      this.themeSettings.secondary = '#f67c7e'
      this.themeSettings.heading = '#2c2c2c'
      this.themeSettings.text = '#626262'
    },
    checkOpen () {
      this.$refs.picker.$data.open = true
    },
    selectDate () {
      this.eachEventPopUp = true
    },
    dateCheck (startDate, endDate) {
      const start_date = Date.parse(startDate)
      const end_date = Date.parse(endDate)
      if (start_date === end_date) {
        return true
      } else {
        return false
      }
    },
    handleEmailDefault (index) {
      this.contact_email.map((item) => {
        item.default = false
      })
      this.contact_email[index].default = true
    },
    saveCurrencySettings () {
      this.$validator.validateAll('CurrencySettings').then((valid) => {
        if (valid) {
          const payload = {
            currency_id: this.currency_id}
          const customer_id = localStorage.getItem('customer_id')
          currencyApi(customer_id, payload).then(data => {
            this.$vs.notify({
              title: 'Success',
              text: 'Currency Updated Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })

          }).catch(e => {
            this.$vs.notify({
              title: 'Error',
              text: e.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
           
          
        } 
      })
      
      
    },
    saveSettings () {
      this.$validator.validateAll('GeneralSettings').then((valid) => {
        if (valid) {
          
          const payload = {
            platform_timezone_id: this.platform_timezone_id,
            contact_email: this.contact_email,
            invitation_setting:this.invitation_setting,
            header: this.header,
            footer:this.footer,
            start_day_id:this.start_day_id,
            date_format_id:this.date_format_id,
            time_format_id:this.time_format_id,
            primary_color: this.themeSettings.primary,
            secondary_color: this.themeSettings.secondary,
            heading_color: this.themeSettings.heading,
            text_color: this.themeSettings.text,
            logo: this.themeSettings.logo_url,
            date_format:this.dateFormat[this.date_format_id - 1].value,
            time_format:this.timeFormat[this.time_format_id - 1].key_val
          }
          /*  
          
          
           */
          // 

          this.updateSettings(payload)
        }
      })
      // 
    },
    async fetchSetting () {
      const customer_id = localStorage.getItem('customer_id')

      const { data } = await getSetting(customer_id)
      console.log(data)
      if (data.data[0] !== null) {
        // 
        this.contact_email = data.data[0].contact_email
        this.currency_id = data.data[0].currency_id
        this.email_template = data.data[0].email_template
        this.platform_timezone_id = data.data[0].platform_timezone_id
        this.start_day_id = data.data[0].start_day_id
        this.date_format_id = data.data[0].date_format_id
        this.time_format_id = data.data[0].time_format_id
        this.header = data.data[0].header
        this.footer = data.data[0].footer
        this.invitation_setting = data.data[0].invitation_setting
        this.can_update_currency = data.data[0].can_update_currency
      }
      localStorage.setItem('localization', JSON.stringify(data.data.data[0]))
      this.SET_LOCALIZATION(data.data.data[0])
      // localStorage.date_format = this.dateFormat[data.data[0].date_format_id - 1].key_val
      // localStorage.time = this.timeFormat[data.data[0].time_format_id - 1].id
      // localStorage.currency_id = data.data[0].currency_id
      
      
    },
    async updateSettings (payload) {
      const customer_id = localStorage.getItem('customer_id')

      try {
        const data = await setSettings(customer_id, payload)

        // console.log(data.data.data[0])

        localStorage.setItem('localization', JSON.stringify(data.data.data[0]))
        this.SET_LOCALIZATION(data.data.data[0])
        localStorage.date_format = this.dateFormat[payload.date_format_id - 1].key_val
        localStorage.time = this.timeFormat[payload.time_format_id - 1].id
        localStorage.currency_id = payload.currency_id

        this.changeThemeColor()
        this.changeLogo = false

        this.showSuccessMessage(
          'Success',
          'Settings Updated Successfully',
          'success'
        )
      } catch (error) {
        console.warn(error)
      }
    },
    deleteemail (index) {
      this.$nextTick(() => {
        this.contact_email.splice(index, 1)
      })
    },
    addNewemail () {
      this.contact_email.push({
        email: null,
        default: false
      })
    },
    changeThemeColor () {
      this.$vs.theme({
        primary: JSON.parse(localStorage.getItem('localization')).primary_color,
        secondary: JSON.parse(localStorage.getItem('localization')).secondary_color,
        heading: JSON.parse(localStorage.getItem('localization')).heading_color,
        text: JSON.parse(localStorage.getItem('localization')).text_color
      })
    },
    getImageUrl (obj) {
      this.themeSettings.logo_url = obj.file_image_url
    },
    removeLogo () {
      this.themeSettings.logo_url = 'https://scoolio-dev.track-progress.com/img/scoolio.8c3f7f84.svg'
    }
  },
  watch : {
    tabIndex () {
      this.initializePopupMutationObserver()
    }
  }
}
</script>

<style>
.holiday-picker .reportrange-text {
  display: none;
}
.holiday-picker .calendars {
  display: flex;
}
.holiday-picker .daterangepicker {
  position: static;
}
.holiday-picker .daterangepicker:before,
.holiday-picker .daterangepicker:after {
  display: none;
}
.holiday-picker .daterangepicker .calendars-container {
  width: calc(100% - 100px);
}
.holiday-picker .daterangepicker .calendars-container .drp-calendar.col.left.single {
  width: 100%;
  max-width: 100%;
}
.cstm_vert_tabs .con-ul-tabs {
  background: #fff;
  margin-right: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}


@media (max-width: 768px) {
  .cstm_vert_tabs .con-ul-tabs {
    margin-right: 0px;
    margin-bottom: 20px;
  }
}
@media(max-width: 480px) {
  .holiday-picker .calendars {
    display: block;
  }
  .holiday-picker .daterangepicker .calendars-container {
    width: 100%;
  }
  .holiday-picker .daterangepicker.single.show-ranges {
    min-width: 100%;
  }
  .holiday-picker .daterangepicker .calendar-table {
    overflow: auto;
  }
}
</style>